import * as React from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Tooltip } from '@mui/material';
import { MenuItemsProps } from './MenuItems.props';
import { StyledMenu, StyledButton } from './MenuItems.styles';

export const MenuItems = ({ label, children }: MenuItemsProps) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const processChildrenWithCloseHandler = (
    children: React.ReactNode
  ): React.ReactNode =>
    React.Children.map(children, (child) => {
      if (React.isValidElement(child)) {
        const childProps = child.props;
        const hasChildren = childProps?.children;

        const additionalProps: {
          onClick?: (event: React.MouseEvent<HTMLElement>) => void;
          children?: React.ReactNode;
        } = {
          onClick: (event: React.MouseEvent<HTMLElement>) => {
            childProps.onClick?.(event);
            handleClose();
          },
        };

        if (hasChildren && child.type !== Tooltip) {
          additionalProps.children = processChildrenWithCloseHandler(
            childProps.children
          );
        }

        return React.cloneElement(child, additionalProps);
      }
      return child;
    });

  return (
    <div>
      <StyledButton
        id="menu-items-btn"
        aria-haspopup="true"
        variant="contained"
        disableElevation
        onClick={handleClick}
        endIcon={<KeyboardArrowDownIcon />}
      >
        {label}
      </StyledButton>
      <StyledMenu
        id="menu-items"
        elevation={0}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        MenuListProps={{
          'aria-labelledby': 'menu-items-btn',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        {...(!open && { inert: 'true' })}
      >
        {processChildrenWithCloseHandler(children)}
      </StyledMenu>
    </div>
  );
};
